module.exports = __webpack_public_path__ + "img/light-sabers.4d262d4e.svg";